import React, { useState, useEffect } from 'react'
import { HStack, parseColor } from '@chakra-ui/react'
import {
  ColorPickerArea,
  ColorPickerContent,
  ColorPickerControl,
  ColorPickerEyeDropper,
  ColorPickerInput,
  ColorPickerRoot,
  ColorPickerSliders,
  ColorPickerTrigger
} from '@/components/ui/color-picker'

function rgbaToHex (rgba) {
  const match = rgba.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/)

  if (match && match.length === 5) {
    const r = parseInt(match[1])
    const g = parseInt(match[2])
    const b = parseInt(match[3])
    const a = parseFloat(match[4]) || 1 // Default alpha to 1 if not specified

    const hexR = r.toString(16).padStart(2, '0')
    const hexG = g.toString(16).padStart(2, '0')
    const hexB = b.toString(16).padStart(2, '0')

    const hexA = Math.round(a * 255).toString(16).padStart(2, '0')

    return `#${hexR}${hexG}${hexB}${hexA}`
  }
}

export default ({ value, onChange }) => {
  const [localValue, setLocalValue] = useState()

  useEffect(() => {
    setLocalValue(parseColor(value || '#000000ff'))
  }, [value])

  return (
    <ColorPickerRoot
      value={localValue}
      format='rgba'
      onValueChange={(e) => setLocalValue(e.value)}
      onValueChangeEnd={(e) => {
        onChange(rgbaToHex(e.valueAsString))
        setLocalValue(e.value)
      }}
      maxW='200px'
    >
      <ColorPickerControl>
        <ColorPickerInput />
        <ColorPickerTrigger />
      </ColorPickerControl>
      <ColorPickerContent portalled={false}>
        <ColorPickerArea />
        <HStack>
          <ColorPickerEyeDropper />
          <ColorPickerSliders />
        </HStack>
      </ColorPickerContent>
    </ColorPickerRoot>
  )
}
